<script lang="ts">
    import SettingsRouteSendTime from '../Settings/SettingsRouteSendTime.svelte';

    export let componentProps: any = {};
</script>

<SettingsRouteSendTime {...componentProps} />
